/* Candywrap v2: knipt de effen achtergrond (meestal wit) van productfoto's weg, zodat ze op de pastelvlakken staan.
   Werkt vanaf de randen (flood fill), dus wit snoep midden in een zak blijft staan.
   Alleen foto's van de eigen winkel (zelfde domein), anders blijft de foto zoals hij is. */
(function () {
  if (window.__cwCut) return; window.__cwCut = true;
  var SEL = '.card--product .card__media:not(.cw-cover):not(.cw-keep) > .media img.card__main-image, .cwh .st:not(.cw-cover):not(.cw-keep) img.is-photo, .cwh .recent .ri img, .cwh .st:not(.cw-cover):not(.cw-keep) .stl img.is-photo';
  var MAX = 640, TOL = 16, HOLE = 5;

  function sameOrigin(src) {
    try { return new URL(src, location.href).origin === location.origin; } catch (e) { return false; }
  }

  /* lukt uitsnijden niet (geen witte achtergrond, andere server), dan toch tonen */
  function process(img) {
    cut(img);
    if (img.complete && img.naturalWidth && !img.__cwPending && !img.hasAttribute('data-cw-cut')) img.setAttribute('data-cw-cut', '0');
  }

  function cut(img) {
    if (!img.complete || !img.naturalWidth) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0 || src.indexOf('blob:') === 0 || !sameOrigin(src)) return;
    if (img.__cwSrc === src) return;
    img.__cwSrc = src;
    var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, MAX / Math.max(w, h));
    w = Math.round(w * k); h = Math.round(h * k);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    var d;
    try { x.drawImage(img, 0, 0, w, h); d = x.getImageData(0, 0, w, h); } catch (e) { return; }
    var p = d.data;
    /* achtergrondkleur uit de hoeken; als een hoek al doorzichtig is, doen we niets */
    var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
    var r = 0, g = 0, b = 0;
    for (var i = 0; i < 4; i++) { var o = corners[i]; if (p[o + 3] < 250) return; r += p[o]; g += p[o + 1]; b += p[o + 2]; }
    r /= 4; g /= 4; b /= 4;
    var isWhite = r > 236 && g > 236 && b > 236;
    if (!isWhite) return;
    var GTOL = isWhite ? 62 : 64, STEP = isWhite ? 5 : 9;
    for (i = 0; i < 4; i++) { o = corners[i]; if (Math.abs(p[o] - r) + Math.abs(p[o + 1] - g) + Math.abs(p[o + 2] - b) > (isWhite ? TOL * 1.5 : 120)) return; }
    var dist = function (o) { return Math.max(Math.abs(p[o] - r), Math.abs(p[o + 1] - g), Math.abs(p[o + 2] - b)); };
    /* flood fill vanaf alle randpixels */
    var seen = new Uint8Array(w * h), stack = [], n = 0;
    var d2 = function (a, b2) { return Math.max(Math.abs(p[a] - p[b2]), Math.abs(p[a + 1] - p[b2 + 1]), Math.abs(p[a + 2] - p[b2 + 2])); };
    var push = function (q, from) {
      if (seen[q]) return;
      var o2 = q * 4;
      if (dist(o2) <= TOL || (dist(o2) <= GTOL && from >= 0 && d2(o2, from * 4) <= STEP)) { seen[q] = 1; stack.push(q); }
    };
    for (var xx = 0; xx < w; xx++) { push(xx, -1); push((h - 1) * w + xx, -1); }
    for (var yy = 0; yy < h; yy++) { push(yy * w, -1); push(yy * w + w - 1, -1); }
    while (stack.length) {
      var q = stack.pop(), qx = q % w; n++;
      if (qx > 0) push(q - 1, q);
      if (qx < w - 1) push(q + 1, q);
      if (q >= w) push(q - w, q);
      if (q < w * (h - 1)) push(q + w, q);
    }
    if (n < w * h * 0.08) return; /* nauwelijks achtergrond gevonden: laat staan */
    for (q = 0; q < w * h; q++) if (seen[q]) p[q * 4 + 3] = 0;
    /* ingesloten gaatjes: alleen pixels die vrijwel exact de achtergrondkleur hebben (studio wit), in eilandjes */
    var lab = new Uint8Array(w * h), st2 = [];
    for (var s0 = 0; s0 < w * h; s0++) {
      if (!isWhite || seen[s0] || lab[s0] || dist(s0 * 4) > HOLE) continue;
      var reg = [], ok = true; lab[s0] = 1; st2.push(s0);
      while (st2.length) {
        var u = st2.pop(), ux = u % w; reg.push(u);
        if (reg.length > w * h * 0.04) ok = false;
        var nb = [ux > 0 ? u - 1 : -1, ux < w - 1 ? u + 1 : -1, u >= w ? u - w : -1, u < w * (h - 1) ? u + w : -1];
        for (var t = 0; t < 4; t++) { var v = nb[t]; if (v >= 0 && !lab[v] && !seen[v] && dist(v * 4) <= HOLE) { lab[v] = 1; st2.push(v); } }
      }
      if (ok && reg.length >= 12) for (t = 0; t < reg.length; t++) { seen[reg[t]] = 1; p[reg[t] * 4 + 3] = 0; }
    }
    /* zachte rand: pixels naast de achtergrond half doorzichtig als ze er bijna op lijken */
    for (q = 0; q < w * h; q++) {
      if (seen[q]) continue;
      var qx2 = q % w;
      if ((qx2 > 0 && seen[q - 1]) || (qx2 < w - 1 && seen[q + 1]) || (q >= w && seen[q - w]) || (q < w * (h - 1) && seen[q + w])) {
        var dd = dist(q * 4);
        if (dd < TOL * 2) p[q * 4 + 3] = Math.round(255 * Math.min(1, (dd - TOL) / (TOL * 1.5) + 0.5));
      }
    }
    x.putImageData(d, 0, 0);
    try {
      img.__cwPending = true;
      c.toBlob(function (blob) {
        img.__cwPending = false;
        if (!blob) { img.setAttribute('data-cw-cut', '0'); return; }
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = URL.createObjectURL(blob);
        img.classList.add('cw-cut-done'); img.setAttribute('data-cw-cut', '1');
      }, 'image/png');
    } catch (e) {}
  }

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (img) {
      if (img.complete && img.naturalWidth) process(img);
    });
  }
  /* lazy geladen foto's: verwerken zodra ze binnen zijn */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.matches && t.matches(SEL)) process(t);
  }, true);
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (nd) { if (nd.nodeType === 1) scan(nd); }); });
  });
  function boot() { scan(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', function () { scan(); });
})();
